function copyFieldValueForRegistration({ state }) {
  let { registrationStep, addresstypes, registration } = state.get('client')

  const copyAddressType = addresstypes[registrationStep.addresstypeIndex - 1]
  const currentType = addresstypes[registrationStep.addresstypeIndex]
  let copyAddressTypeFields = state.get(
    `client.registrating.current.${copyAddressType}`
  )
  let currentTypeFields = state.get(
    `client.registrating.current.${currentType}`
  )
  let copy = {}
  registration.forEach(field => {
    let performAdd = true
    if (field.excludeFrom && field.excludeFrom.length > 0) {
      if (field.excludeFrom.indexOf(currentType) !== -1) {
        performAdd = false
      }
    }
    if (performAdd) {
      if (copyAddressTypeFields[field.identifier]) {
        copy[field.identifier] = {
          ...copyAddressTypeFields[field.identifier]
        }
      } else {
        copy[field.identifier] = {
          ...currentTypeFields[field.identifier]
        }
      }
    }
  })
  state.set(
    `client.registrating.current.${addresstypes[registrationStep.addresstypeIndex]}`,
    copy
  )
}

export default copyFieldValueForRegistration



// WEBPACK FOOTER //
// ./src/modules/login/actions/copyFieldValueForRegistration.js